import { SectionCard } from '../../regional/BucketStates';

import { useRegionActivity } from './regionsQueries';

interface Props {
  regionId: string;
}

/** Compact relative time, e.g. "2 days ago" / "just now". */
function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const secs = Math.round((Date.now() - then) / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} min${mins === 1 ? '' : 's'} ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? '' : 's'} ago`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  return new Date(iso).toLocaleDateString();
}

/** Recent activity for a region — the audit feed (BON-160). */
export function RegionActivityCard({ regionId }: Props) {
  const activityQ = useRegionActivity(regionId);
  const entries = activityQ.data ?? [];

  let body;
  if (activityQ.isLoading) {
    body = <div style={{ fontSize: 12.5, color: 'var(--nb-subtle)' }}>Loading…</div>;
  } else if (entries.length === 0) {
    body = (
      <div style={{ fontSize: 12.5, color: 'var(--nb-subtle)' }}>No activity recorded yet.</div>
    );
  } else {
    body = (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {entries.map((e) => (
          <div key={e.id} style={{ fontSize: 12.5, color: 'var(--nb-ink)' }}>
            <span style={{ fontWeight: 700 }}>{e.actorName}</span> {e.summary}
            <div style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>
              {relativeTime(e.createdAt)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return <SectionCard title="Recent activity">{body}</SectionCard>;
}
